import React from "react";
import { useAppContext } from "../context/AppContext";
import OrganisationProfileForm from "../components/settings/OrganisationProfileForm";

const SimpleClientData = () => {
  const { client } = useAppContext();

  const handleSave = async (updatedData) => {
    // You can send updatedData to your API here
    console.log("Saving updated client data:", updatedData);
    // await fetch("/api/clients/current", { method: "PUT", ... })
  };

  if (!client) {
    return <p>Loading client data...</p>;
  }

  return (
    <div className="p-4">
      <OrganisationProfileForm client={client} onSave={handleSave} />
    </div>
  );
};

export default SimpleClientData;
